import { SerieCache } from './SerieCache';
import { cleanPrefix } from '../../../../../util/useServerConfig';

export const cache = {
  studies: {},
};

export const getParams = (instance) => {
  // const url = new URL(instance.replace('', '').replace('wadouri:', ''));

  const url = new URL(cleanPrefix(instance));
  const params = new URLSearchParams(url.search);

  const studyUID = params.get('studyUID') || instance.match(/studies[.\/][.0-9]*/)[0].replace('studies/', '');
  const seriesUID = params.get('seriesUID') || instance.match(/series[.\/][.0-9]*/)[0].replace('series/', '');
  const objectUID = params.get('objectUID') || instance.match(/instances[.\/][.0-9]*/)[0].replace('instances/', '');

  return { studyUID, seriesUID, objectUID };
};


/**
 * @returns {SerieCache}
 */
export const findOrNewSerieCache = (instances) => {
  const params = getParams(instances[0]);

  const study = cache.studies[params.studyUID];
  const serie = study && study[params.seriesUID];

  if (!study || (study && !serie)) {
    cache.studies = {
      [params.studyUID]: {
        ...study,
        [params.seriesUID]: new SerieCache({ instances }),
      },
    };
  }

  return cache.studies[params.studyUID][params.seriesUID];
};
